export class DeleteHaircutRowCommand {
  currency: string;
}
